module.exports = __webpack_public_path__ + "img/nodata.20e4a65d.jpg";